import { z } from '../zod.js';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';
import {
  CHARGE_STATUS,
  ORDER_STATUS,
  ChargeStatusValidationEnum,
  OrderStatusValidationEnum,
  ChargeAbandonmentStatusValidationEnum,
} from '../charge/enum';

export const BookingListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend({
    search: z.string().optional().meta({
      description:
        "Search by customerEmail, customerName, eventTitle, or orderId. Contains match (e.g. 'jane' matches 'jane@example.com', 'Doe' matches 'Jane Doe', 'Summit' matches 'Future of AI Summit 2026').",
    }),
    status: ChargeStatusValidationEnum.optional().meta({
      description: `Filter by payment status. Valid values: ${Object.values(CHARGE_STATUS).join(', ')}.`,
    }),
    orderStatus: OrderStatusValidationEnum.optional().meta({
      description: `Filter by order status. Valid values: ${Object.values(ORDER_STATUS).join(', ')}.`,
    }),
    pageId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter by event ID.',
    }),
    customerId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter by customer ID.',
    }),
    orderId: z.string().optional().meta({ description: 'Filter by order ID.' }),
    couponCode: z.string().optional().meta({
      description: 'Filter by coupon code.',
    }),
    createdAfter: z.iso.datetime().optional().meta({
      description: 'Filter by lower bound of createdAt.',
    }),
    createdBefore: z.iso.datetime().optional().meta({
      description: 'Filter by upper bound of createdAt.',
    }),
    abandonmentStatus: ChargeAbandonmentStatusValidationEnum.optional().meta({
      description: 'Filter by `abandoned` or `recovered` bookings.',
    }),
    isComplimentary: z
      .enum(['true', 'false'])
      .transform(v => v === 'true')
      .optional()
      .meta({
        description:
          'Filter by complimentary bookings. `true` returns only complimentary bookings, `false` excludes them.',
      }),
    archived: z
      .enum(['true', 'false'])
      .transform(v => v === 'true')
      .optional()
      .meta({
        description:
          'Filter by archived bookings. `true` returns only archived bookings, `false` excludes them. Without it the list includes both.',
      }),
    livemode: LivemodeFilterValidationSchema,
  }).refine(
    data =>
      !(
        data.createdAfter &&
        data.createdBefore &&
        Date.parse(data.createdAfter) > Date.parse(data.createdBefore)
      ),
    {
      message: 'createdAfter must be earlier than or equal to createdBefore',
      path: ['createdBefore'],
    },
  ),
);
